// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UQe5E","colorValue":"styles_colorValue__NNBpy","fadeInOut":"styles_fadeInOut__4JNmL","loader":"styles_loader__NZUye"};